import * as yup from "yup";
import { MSG } from "../constants/MSG";
export const promotionSchema = yup.object().shape({
	title: yup
		.string()
		.trim()
		.max(25, MSG.PROMOTION_TITLE_LENGTH)
		.required(MSG.PROMOTION_TITLE)
		.nullable(MSG.PROMOTION_TITLE),
	subtitle: yup.string().max(40, MSG.PROMOTION_SUBTITLE_LENGTH).nullable(),
	body: yup
		.string()
		.trim()
		.max(120, MSG.PROMOTION_BODY_LENGTH)
		.required(MSG.PROMOTION_BODY)
		.nullable(MSG.PROMOTION_BODY),
});
